import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { CATEGORY_LABELS, formatDate } from "@/lib/data";
import AddSessionDialog from "@/components/partner/AddSessionDialog";

export default function Sessions() {
  const { data: sessions = [] } = useQuery({ queryKey: ["partner-sessions"], queryFn: () => get("/partner/sessions") });

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Seanslar</h1>
          <p className="text-sm text-[#64748B]">Toplam {sessions.length} seans</p>
        </div>
        <AddSessionDialog />
      </div>

      <div className="overflow-hidden rounded-md border border-[#E2E8F0] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#F1F5F9] text-left text-xs uppercase tracking-wide text-[#64748B]">
            <tr>
              <th className="px-4 py-3">Seans</th>
              <th className="px-4 py-3">Kategori</th>
              <th className="px-4 py-3">Tarih & Saat</th>
              <th className="px-4 py-3">Eğitmen</th>
              <th className="px-4 py-3">Doluluk</th>
              <th className="px-4 py-3 text-right">Kredi</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">
            {sessions.map((s) => {
              const occ = Math.round((s.booked_count / s.capacity) * 100);
              return (
                <tr key={s.id} data-testid={`session-row-${s.id}`} className="transition-colors hover:bg-[#F7F9FA]">
                  <td className="px-4 py-3 font-medium">{s.title}</td>
                  <td className="px-4 py-3 capitalize text-[#475569]">{CATEGORY_LABELS[s.category]}</td>
                  <td className="px-4 py-3 text-[#475569]">{formatDate(s.date)} · {s.start_time}</td>
                  <td className="px-4 py-3 text-[#475569]">{s.instructor}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className="h-1.5 w-16 overflow-hidden rounded-full bg-[#E2E8F0]"><div className="h-full bg-[#2D2926]" style={{ width: `${occ}%` }} /></div>
                      <span className="text-xs text-[#64748B]">{s.booked_count}/{s.capacity}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-right font-medium">{s.credit_price}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
